import { media, Pagination } from 'ia-react-core';
import { PageMainTitle } from 'omni-package-react-core';
import styled from 'styled-components';

export const StyledTitle = styled(PageMainTitle)`
  text-align : center;
  ${media.sm`
    text-align: left;
  `};
`;
export const StyledPagination = styled(Pagination)` 
  place-content: center;
  ${media.sm`
    place-content: inherit;
  `};
`;
